var render = function render(){var _vm=this,_c=_vm._self._c;return _c('YLayoutBodyMenu',{attrs:{"menu":[
    {title:'基础配置',path:'/shop/plugin/area-agent/conf'},
    {title:'代理管理',path:'/shop/plugin/area-agent/manage'},
    {title:'升级商品',path:'/shop/plugin/area-agent/goods'},
]}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }